import { BET_TYPE, BetError, EventBuss } from '@/utils/constants'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import AppSvg from '@/components/app-svg.vue'
import { PopAlertModel } from '@/datamodel/types'
import { useI18n } from 'vue-i18n'

@Options({
    components: {
        'app-svg': AppSvg
    }
})
export class BetAreaViewMixin extends Vue {
    iN = useI18n().t
    @Prop({ default: '1:1' }) betRatio!: string
    @Prop({ default: -1 })
    betType!: number
    @Prop({ default: -1 })
    offSet!: number
    @Prop({ default: false })
    allowBet!: boolean
    @Prop({ default: false })
    isGrayMode!: boolean
    @Prop({ default: '' })
    grayModeError!: string

    @Prop({ default: -1 })
    currentIndex!: number
    @Prop({ default: 0 })
    tempAmount!: number
    @Prop({ default: 0 })
    confirmedAMount!: number

    @Prop({ default: -1 })
    chipValue!: number

    @Prop({ default: false })
    showFlash!: boolean

    @Prop({ default: false })
    isOnMultipleBet!: boolean

    $emit!: Vue['$emit']

    handleBetClicked(): void {
        if (this.isGrayMode && this.allowBet) {
            let _error = this.grayModeError
            if (!_error) {
                if (this.betType === BET_TYPE.DRAGON_7) {
                    _error = this.iN('prompt.d7error')
                } else if (this.betType === BET_TYPE.BEAR_8) {
                    _error = this.iN('prompt.b8error')
                } else if (this.betType === BET_TYPE.BIG_TIGER) {
                    _error = this.iN('prompt.bigtigererror')
                } else if (this.betType === BET_TYPE.SMALL_TIGER) {
                    _error = this.iN('prompt.smalltigererror')
                } else if (this.betType === BET_TYPE.SUPER6) {
                    _error = BetError.SUPER6_TIGER_CONFLICT
                }
            }

            if (!this.isOnMultipleBet) {
                const popError: PopAlertModel = {
                    type: 0,
                    header: '',
                    message: _error,
                    color: ''
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            } else {
                this.$emit('on-show-pop-alert', _error)
            }

            return
        }

        if (this.chipValue > 0 && this.allowBet)
            this.$emit('place-bet', this.betType)
    }

    cancelBet(): void {
        this.$emit('cancel-bet')
    }

    confirmBet(): void {
        this.$emit('on-confirm-bet')
    }

    get betLabel(): string {
        switch (this.betType) {
            case BET_TYPE.BANKER:
            case BET_TYPE.BANKER_SUPER6:
                return '庄'
            case BET_TYPE.BANKER_PAIR:
                return '庄对'
            case BET_TYPE.PLAYER:
                return '闲'
            case BET_TYPE.PLAYER_PAIR:
                return '闲对'
            case BET_TYPE.BC_TIE:
            case BET_TYPE.DT_TIE:
                return '和'
            case BET_TYPE.DRAGON:
                return '虎'
            case BET_TYPE.TIGER:
                return '龙'
            case BET_TYPE.SUPER6:
                return 'SUPER 6'
            case BET_TYPE.BEAR_8:
                return '熊8'
            case BET_TYPE.SMALL_TIGER:
                return '小老虎'
            case BET_TYPE.BIG_TIGER:
                return '大老虎'
            case BET_TYPE.DRAGON_7:
                return '龙7'
        }
        return ''
    }

    get color(): string {
        let result = ''
        switch (this.betType) {
            case BET_TYPE.BANKER:
            case BET_TYPE.TIGER:
            case BET_TYPE.BANKER_PAIR:
            case BET_TYPE.BANKER_SUPER6:
            case BET_TYPE.DRAGON_7:
                result = 'red'
                break
            case BET_TYPE.PLAYER:
            case BET_TYPE.DRAGON:
            case BET_TYPE.PLAYER_PAIR:
            case BET_TYPE.BEAR_8:
                result = 'blue'
                break
            case BET_TYPE.BC_TIE:
            case BET_TYPE.DT_TIE:
                result = 'green'
                break
            case BET_TYPE.SUPER6:
            case BET_TYPE.SMALL_TIGER:
            case BET_TYPE.BIG_TIGER:
                result = 'super6'
                break
        }

        if (!this.allowBet) {
            return result + '-blur'
        }
        return result
    }

    get amount(): string {
        return (this.tempAmount + this.confirmedAMount).toString()
    }

    get needToDisPlayAmount(): boolean {
        const total = this.tempAmount + this.confirmedAMount

        return total > 0
    }

    get hasUnConfirmedBet(): boolean {
        return this.tempAmount > 0
    }

    get hasNoBet(): boolean {
        return this.tempAmount + this.confirmedAMount <= 0
    }

    get hasBetConfirmedBet(): boolean {
        return this.confirmedAMount > 0
    }
}
